import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import IndustryScaleProxy from './proxy'

class IndustryScaleService extends ServiceBase {
  getIndustryScaleTable(params) {
    return this.getData(() => IndustryScaleProxy.getIndustryScaleTable(params))
  }
  downloadIndustryScale(params) {
    return this.getFileDownload(() =>
      IndustryScaleProxy.downloadIndustryScale(params),
    )
  }
}

export default new IndustryScaleService()
